package com.evoapps.evoshift.data.dto.finance

import kotlinx.serialization.Serializable

@Serializable
data class ShiftFinancialsDto(
    val shiftId: String,
    val rosterId: String,
    val dailyRecordId: String,
    val date: String,
    val ratesSnapshot: RatesSnapshotDto,
    val costs: ShiftCostsDto,
    val userId: String? = null
)

@Serializable
data class RatesSnapshotDto(
    val rateUsed: Double,
    val employerRateUsed: Double,
    val contractType: String,
    val currency: String,
    val market: String = "POLAND",
    val plannedHours: Double = 0.0,
    val nightHours: Double = 0.0
)

@Serializable
data class ShiftCostsDto(
    val estimatedPayout: Double,
    val employerCost: Double,
    val actualPayout: Double,
    val otherCosts: Map<String, Double> = emptyMap(),
    val nightAllowance: Double = 0.0,
    val employerContributions: Double = 0.0,
    val actualEmployerCost: Double? = null
)
